/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
import 'url-polyfill'
import ismobile from 'is-mobile'
import queryString from 'querystring'
import {
  sendCommand,
  vbaSendCommand,
  closeWebView,
  checkApiSupport,
  isWPSClient,
  getAppInfo,
  checkCloudFeatureSupport,
} from '@util/wpsoffice'
// @ts-ignore
import { SaasAxios } from '@quick/saas-axios'
import _pickBy from 'lodash/pickBy'
import wx from 'weixin-js-sdk'
import { GetQueryOptions } from './types'
import clientApi from '@plus/client-connect'
import { getBusinessGuideStatus } from '@util//business'
import singleSign from '@plus/single-sign'
import { removeBase64Padding } from '@util/common'

function removeNullObjectKey(obj) {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, 'key')) {
      if (!obj[key]) {
        delete obj[key]
      }
    }
  }
}

/**
 * 判断是否为FormData格式
 */
export function isFormData(data) {
  return data instanceof FormData
}

/**
 * 判断是否移动端
 */
export const isMobile = (): boolean => {
  // 应金山文档、woa Anpad及产品诉求：部分安卓平板的ua里面含有mobile字段，当前包用这个标签来判断的话并不准确
  if (
    /android-woa.*appIsTablet|appIsTablet.*android-woa/.test(
      navigator.userAgent
    ) ||
    navigator.userAgent.includes('device_model/androidPad') ||
    getBusinessGuideStatus() // 专用包容器弹窗，避免被识别为移动端
  ) {
    return false
  }
  return ismobile()
}

/**
 * 判断是否Iframe
 */

export const isIframe = () => {
  return self != top
}

// 判断是否是wps小程序框架，兼容iframe与非iframe场景
export const isWPSMiniProgram = () => {
  if (!isWPSClient()) return false
  const isIframeBol = isIframe()

  if (isIframeBol) {
    try {
      const w = window.top
      return w?.['__wpsoffice_environment'] === 'miniprogram'
    } catch (error) {
      return false
    }
  } else {
    return window.__wpsoffice_environment === 'miniprogram'
  }
}

export const getQuery = (
  name: string = '',
  url: string = '',
  options: GetQueryOptions = { stringify: false, params: {} }
) => {
  try {
    const tempUrl = ~url.indexOf('?')
      ? url.slice(url.indexOf('?') + 1)
      : '' || window.location.search.substr(1)
    const urlParams = Object.assign(queryString.parse(tempUrl), options.params)
    // 去重，避免携带重复字段
    for (const key in urlParams) {
      if (Array.isArray(urlParams[key])) {
        // @ts-ignore
        urlParams[key] = urlParams[key]?.pop() || ''
      }
    }
    //删除value未空的参数
    removeNullObjectKey(urlParams)
    if (name) {
      return urlParams[name]
    } else {
      if (options.stringify) {
        return queryString.stringify(urlParams)
      }
      return urlParams
    }
  } catch {
    return ''
  }
}
window.getQuery = getQuery
/**
 * 获取终端类型
 */
export const getUtmSource = () =>
  window.$regPlatformInfo?.utm_source || getQuery('utm_source')

/**
 * @desc 获取url query的所有utm参数
 * */
export const getAllUtmInfo = () => {
  const queryInfo = getQuery() || {}

  const utmInfo = _pickBy(queryInfo, (value, key) => key.includes('utm_'))
  // sdk透传参数
  const regPlatformUtmInfo = _pickBy(window.$regPlatformInfo, (value, key) =>
    key.includes('utm_')
  )

  if (!utmInfo || !Object.keys(utmInfo).length) {
    return {
      ...getOtherUtmByRefer(),
      utm_source: getSourceByRefer(false),
      ...regPlatformUtmInfo,
    }
  } else {
    return {
      ...utmInfo,
      utm_source: utmInfo['utm_source'] || getSourceByRefer(true),
      ...regPlatformUtmInfo,
    }
  }
}

export const loginAction = time => {
  setTimeout(() => {
    location.href = `//account.wps.cn/?cb=${encodeURIComponent(location.href)}`
  }, time)
}
export const getAppVersion = () => {
  return new Promise((resolve, reject) => {
    try {
      window.wps.getAppVersion({
        complete: ret => {
          resolve(ret.data.app_version)
        },
      })
    } catch (e) {
      reject(e)
    }
  })
}

// 获取pcVersion
export const getPcVersion = () => {
  try {
    let version = window?.appInfo?.version
    version = version && Number(version.replace(/\./g, ''))
    return version
  } catch {
    return ''
  }
}
/**
 * 判断是否微信浏览器，主动传入wx对象，不希望全局导入wxsdk
 * @param {*} wx
 */
export const isWechat = wx => {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase()
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  return new Promise((resolve, reject) => {
    try {
      if (ua.indexOf('micromessenger') === -1) {
        //不在微信或者小程序中
        resolve('other')
      } else {
        wx.miniProgram.getEnv(res => {
          if (res.miniprogram) {
            //在小程序中
            resolve('miniprogram')
          } else {
            //在微信中
            resolve('wechat')
          }
        })
      }
    } catch (e) {
      reject(e)
    }
  })
}
const toWorkbench = (cid: string | number) => {
  singleSign.onSkipSingleSign({
    cbUrl: `${SaasAxios.getHost('KDOCS')}/ent/${cid}/helper`,
  })
  return
}

const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1)
// 处理sdk跳转
const registerPlatformnextProcess = (link = '', paramObject) => {
  const routeName = link.split('?')[0]
  const str = routeName.replace('/', '')
  const targetPage = capitalizeFirstLetter(str)
  window.$nextProcess({
    targetPage,
    paramsInfo: {
      companyId: paramObject?.comp_id,
      groupId: paramObject?.groupId,
    },
  })
}
/**
 * 跳转，会自动附带url参数，相同的会通过传进的url参数覆盖querystring上的相同参数
 */
export const ConditionalJumpLink = {
  pushState: function (
    link = '',
    paramObject = { comp_id: '', groupId: '' },
    needReload = true,
    options = { title: '', state: '' }
  ) {
    setTimeout(() => {
      // 处理sdk跳转
      if (!window?.$initRouteVueMode && link.indexOf('//') < 0) {
        registerPlatformnextProcess(link, paramObject)
        return
      }

      if (link.indexOf('//') < 0) {
        // 如果在3rd域名下，原来的路径 pushState 会有问题，需要特殊处理
        if (window.location.href.indexOf('3rd') > -1) {
          link = '/3rd/plus' + link
        }
        link = window.location.origin + link
      }
      if (/^\/\//.test(link)) {
        link = window.location.protocol + link
      }
      const preUrl = ~link.indexOf('?')
        ? link.slice(0, link.indexOf('?'))
        : link
      let params: any = Object.assign(
        {},
        getQuery(),
        getQuery('', link),
        paramObject
      )
      removeNullObjectKey(params)
      params = queryString.stringify(params as any)
      const url = new URL(link)
      const origin = window.location.origin
      if (origin === url.origin) {
        window.history.pushState(
          options.state,
          options.title,
          preUrl + '?' + params
        )
        needReload && window.location.reload()
      } else {
        window.location.href = mergeURLParams(preUrl + '?' + params, {
          utm_source: getUtmSource(),
        })
      }
    }, 300)
  },
  replaceState: function (
    link,
    paramObject = {},
    needReload = true,
    options = { title: '', state: '' }
  ) {
    try {
      setTimeout(() => {
        if (!window?.$initRouteVueMode && link.indexOf('//') < 0) {
          registerPlatformnextProcess(link, needReload)
          return
        }

        if (link.indexOf('//') < 0) {
          if (window.location.href.indexOf('3rd') > -1) {
            link = '/3rd/plus' + link
          }
          link = window.location.origin + link
        }
        if (/^\/\//.test(link)) {
          link = window.location.protocol + link
        }
        const preUrl = ~link.indexOf('?')
          ? link.slice(0, link.indexOf('?'))
          : link
        let params: any = Object.assign(
          {},
          getQuery(),
          getQuery('', link),
          paramObject
        )
        removeNullObjectKey(params)
        params = queryString.stringify(params as any)
        const url = new URL(link)
        const origin = window.location.origin
        if (origin === url.origin) {
          window.history.replaceState(
            options.state,
            options.title,
            mergeURLParams(preUrl + '?' + params, {
              utm_source: getUtmSource(),
            })
          )

          needReload && window.location.reload()
        } else {
          window.location.href = mergeURLParams(preUrl + '?' + params, {
            utm_source: getUtmSource(),
          })
        }
      }, 300)
    } catch (error) {
      /* eslint-disable */
      console.log(error)
    }
  },
  go: function (num) {
    window.history.go(num)
    window.location.reload()
  },
  open: function (link, paramObject) {
    const preUrl = ~link.indexOf('?') ? link.slice(0, link.indexOf('?')) : link
    let params = Object.assign(
      {},
      getQuery(),
      getQuery('', link),
      paramObject
    )
    removeNullObjectKey(params)
    params = queryString.stringify(params)
    const opener = window.open(preUrl + '?' + params)
    return opener
  },
}
window.ConditionalJumpLink = ConditionalJumpLink

/**
 * 处理url，有?时&附加，无时?开头附加
 * @param {*} url
 * @param {*} paramsObject
 */
export const mergeURLParams = (url, paramsObject) => {
  ~url.indexOf('?') ? url : (url = url += '?')
  let val
  for (const key in paramsObject) {
    if (paramsObject.hasOwnProperty(key)) {
      val = paramsObject[key]
      if (~url.indexOf(key + '=')) {
        let reg = new RegExp(`(${key})=\\w+`)
        url = url.replace(reg, (match, v1) => {
          return val ? `${v1}=${val}` : ''
        })
      } else {
        val && (url += `&${key}=${val}`)
      }
    }
  }
  //去掉末尾错误?/&
  const regex = /(&|\?)$/
  if (regex.test(url)) {
    url = url.replace(regex, '')
  }
  return url
}
export const getBuySource = () => {
  const buysource = getQuery('utm_buysource') || 'plus'
  return buysource
}

export const isWXBrowser = () => {
  const ua = navigator.userAgent.toLowerCase()
  return (
    ua.match(/MicroMessenger/i)?.[0] == 'micromessenger' &&
    window.__wxjs_environment === 'browser'
  )
}
export const isPCminiProgram = () => {
  let ua = window.navigator.userAgent.toLowerCase()
  if (/miniprogramenv\/windows/.test(ua)) {
    return true
  }
  return false
}

/**
 * 去除空格,默认去除前后空格
 * @param {*} txt
 * @param {string} type AL:所有空格 SE:前后空格 S:前空格 E:后空格
 */
export const replaceSpace = (txt, type = 'SE') => {
  if (!txt) return ''
  if (typeof txt !== 'string') return txt
  switch (type) {
    case 'AL':
      return txt.replace(/\s+/g, '')
    case 'SE':
      return txt.replace(/^\s+|\s+$/g, '')
    case 'S':
      return txt.replace(/^\s+/, '')
    case 'E':
      return txt.replace(/\s+$/, '')
    default:
      return txt.replace(/^\s+|\s+$/g, '')
  }
}


/**
 * 获得目标类型
 */
export const $type = obj => {
  const class2type = {
    '[object Array]': 'array',
    '[object Boolean]': 'boolean',
    '[object Date]': 'date',
    '[object Function]': 'function',
    '[object Number]': 'number',
    '[object Object]': 'object',
    '[object RegExp]': 'regexp',
    '[object String]': 'string',
  }
  return obj == null
    ? String(obj)
    : class2type[Object.prototype.toString.call(obj)] || 'object'
}
export const getSourceByRefer = (hasOtherUtm = true, reffer = document.referrer) => {
  try {
    if (!reffer && hasOtherUtm) {
      return 'plus'
    } else if (!reffer && !hasOtherUtm){
      return 'empty'
    }
    let url = new URL(reffer)
    if (url.pathname !== '/' && url.pathname.includes('blog')) {
      return url.pathname.split('/')[1]
    } else {
      if (url.host === 'plus.wps.cn' || url.host === 'account.wps.cn') {
        return 'plus'
      }
      if (/wps\.cn$/.test(url.host)) {
        return 'wps'
      }
      //非wps域名
      const host = url.host.match(/(\w+)\.(?:com|cn|org|cc|edu)/i)
      if (host && host.length >= 2) {
        const name = host[1]
        if (host) {
          if (
            ['baidu', '360so', 'so', 'sogou', 'google', 'bing'].includes(name)
          ) {
            return name
          }
        }
      }
      return reffer.substring(0, 80)
    }
  } catch(e) {
    return 'empty'
  }
}

export const getOtherUtmByRefer = (reffer = document.referrer) => {
  if (!reffer) return {};
  let url = new URL(reffer)
  if (url.search === '') return {};
  const refferParams = getQuery('', reffer)
  const refferUtm = _pickBy(refferParams, (value, key) => key.includes('utm_'))
  return refferUtm
}

/**
 * 匹配url
 * @param {*} url
 * @return {array} [1]:protocol [3]:host [4]:port [5]:path [6]:query
 */
export const urlRegex = url => {
  const regex = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/
  return regex.exec(url || window.location.href)
}

const toPcOfficeHome = async (companyId, groupid, appVersion, defaultUrl,  isVBA, isIframeBol) => {
  const clientName = clientApi.getCurrentClient()
  const utmSource = getUtmSource()
  if (isIframeBol) {
    // 适配当前打开的页面是通过pc的Iframe打开的
    window.parent.postMessage(
      JSON.stringify({
        eventName: 'closeCreateGuideIframe',
        companyid: companyId,
        tempId: groupid,
        groupId: groupid
      }),
      '*'
    )
    return
  }
  // try {
  //   const userid = window._store.state.user.USER_Account.userid
  //   clientApi.switchAccount({ clientName, userid, companyid: companyId })
  // } catch (e) {}
  // vba流程
  if (isVBA) {
    const from = (await getCurrentSource()) || ''
    const source = from ? `&1&1&${from}` : '' // &1&1由于客户端历史遗留取值问题导致 客户端@张展鹏
    vbaSendCommand(`plugin://pageStartPage?locateCloudCompany&activate&${companyId}${source}`)
    return
  }
  // 根据版本号，及非365wps
  if (utmSource !== 'WPS365_PC' && appVersion && appVersion >= 111010640) {
    const params = btoa(JSON.stringify({
      enterpriseId: String(companyId),
      groupId: String(groupid)
    }))
    window.location.href = `ksoqing://type=ksolaunch&soruce=xxx&cmd=L3Byb21ldGhldXMgcGx1Z2luOi8vcGFnZVN0YXJ0UGFnZT9sb2NhdGVDbG91ZENvbXBhbnkmYWN0aXZhdGUmMA==&token=400e11ba62423cacae5ba09dcf853c24&ext=${params}&cert_token=cwTyYldhAbNmT02uq4JXSJSqAfMbaMpGNq6BssrZ8d0+S3hK8mnuhfAmY2AKX2KU3F48vV9pTfJ/pWTyvr6rUqfqqep5jaaRkHFFCWNwelSpehS9I1uBk/Cn62l3e6p9A4Uhx9L+zuGt/pGLsbrcI2Qe0IlavPoQ2Weplw0V7snHtzReZ6QvVE5C//wRhgIfRcKAvr5GsxoOEt3KKCsTugTsnBpGT/dJacFB8nWAfdLzTGVAwiZXVeph33EHW9AcUle3p7JtIpNZBeQAcUEQjKtO7YeBTggBBC4Rm6dNBj9djfCmyQ4LCjIC40X3Fn76LUwXfz7KksxpUb/rFv7g4w==&cert_type=fixurl&business_from=enterprise`
  } else {
    // 客户端
    checkApiSupport('sendCommand', async (res) => {
      // 检查是否有这个sendCommand方法
      if (!res) {

        // 检查是否有common.wpscloud.checkCloudFeatureSupport这个方法
        checkApiSupport('common.wpscloud.checkCloudFeatureSupport',async (checkCFData) => {
          if (!checkCFData) {
            // 检查是否支持jumpToCloudLocation功能
            checkCloudFeatureSupport('jumpToCloudLocation', async jumpData => {
              const resJumpData = jumpData && JSON.parse(jumpData)
              if (!resJumpData) return
              // 如果支持jumpToCloudLocation功能，则走新逻辑跳转
              if (resJumpData && resJumpData.support === 'true') {
                jumpToCloudLocation(true, groupid, companyId)
              } else {
                // 否则走旧逻辑跳转
                jumpToCloudLocation(false, groupid, companyId)
              }
            })
          } else {
            // 否则走旧逻辑跳转
            jumpToCloudLocation(false, groupid, companyId)
          }
        })

      } else {
        ConditionalJumpLink.pushState(defaultUrl)
      }
    })
  }
  setTimeout(() => {
    // mac需要特殊关闭
    if (clientName === 'isWpsMacClient') {
      closeWebView({
        webviewId: 'dcm',
      })
    } else {
      window.close()
    }
  }, 1000)
}

// 跳转客户端方法, isNew为true时，走新逻辑，否则走旧逻辑
const jumpToCloudLocation = async (isNew, groupid, companyId) => {
  if (isNew && groupid) {
    const params = {
      action: 'jumpToCloudLocation',
      groupId: `${groupid}` // groupId 必须是字符串
    }
    const base64Str = btoa(JSON.stringify(params))
    sendCommand(
      `plugin://pageStartPage?${removeBase64Padding(base64Str)}`
    )
    return;
  }
  const from = (await getCurrentSource()) || ''
  const source = from ? `&1&1&${from}` : '' // &1&1由于客户端历史遗留取值问题导致 客户端@张展鹏
  sendCommand(
    `plugin://pageStartPage?locateCloudCompany&activate&${companyId}${source}`
  )
}

// 跳转webDocs方法
const toWebDocsHome = (companyId, groupid, isIframeBol, additionParams = {}) => {
  const { isGuideWorkbench } = additionParams as { isGuideWorkbench?: boolean };
  let type = 'groupid'
  if (!companyId) return false
  if (!groupid) type = 'companyId'
  const docsActions = new Map([
    ['true_groupid', () => {
      const eventName = isGuideWorkbench ? 'toWorkSpacePage' : 'toTeamPage'
      window.parent.postMessage(
        JSON.stringify({
          eventName: eventName,
          companyid: companyId,
          tempId: groupid
        }),
        '*'
      )
    }],
    ['false_groupid', () => {
      console.log('false_groupid')
      if(isGuideWorkbench){
        toWorkbench(companyId)
        return
      }
      singleSign.onSkipSingleSign({ cbUrl: `${SaasAxios.getHost('KDOCS')}/ent/${companyId}/${groupid}` })
      // window.location.href = `https://www.kdocs.cn/ent/${companyId}/${groupid}`
    }],
    ['false_companyId', () => {
      // console.log('false_companyId')
      singleSign.onSkipSingleSign({ cbUrl: `${SaasAxios.getHost('KDOCS')}/ent/${companyId}/helper` })
      // window.location.href = `https://www.kdocs.cn/ent/${companyId}/helper`
    }],
    ['true_companyId', () => {
      // 跳转到企业
      window.parent.postMessage(
        JSON.stringify({
          eventName: 'toCompanyPage',
          companyid: companyId,
        }),
        '*'
      )
    }],
    ['default', () => {
      singleSign.onSkipSingleSign({ cbUrl: `${SaasAxios.getHost('KDOCS')}/ent/${companyId}/helper` })
      // window.location.href = `https://www.kdocs.cn/ent/${companyId}/helper`
    }]
  ])
  let action = docsActions.get(`${isIframeBol}_${type}`) || docsActions.get('default')
  action && action()
}


/**
 * 进入企业内嵌首页
 * @param {*} companyId
 * @noSwitchAccount {boolean} 是否切换账号, 默认false, 切换账号会导致页面跳转到企业助手或者首页
 */
export const goHomeByClient = (
  companyId: number | string = '',
  companyName = '',
  groupid: number | string = '',
  additionParams = {}
  // noSwitchAccount = false,
  // isEntgroups = false, // 跳转到团队列表
) => {
  const {
    isGuideWorkbench,
    noSwitchAccount = false,
    isEntgroups = false // 跳转到团队列表
  } = additionParams as any

  const userid = window._store?.state?.user?.USER_Account?.userid
  const url = `${SaasAxios.getHost('KDOCS')}/ent/${companyId}`
  const isIframeBol = isIframe()
  const source = getQuery('utm_source')
  const defaultAction = () => {
    if(isGuideWorkbench){
      toWorkbench(companyId)
      return
    }
    if (isEntgroups) {
      singleSign.onSkipSingleSign({ cbUrl: `${SaasAxios.getHost('KDOCS')}/entgroups` })
    } else {
      ConditionalJumpLink.pushState(url)
    }
  }
  const iframeAction = () => {
    // 适配当前打开的页面是通过pc的Iframe打开的
    window.parent.postMessage(
      JSON.stringify({
        eventName: 'closeCreateGuideIframe',
      }),
      '*'
    )
  }
  const wps365 = () => {
    // 兼容wps365内嵌金山文档时的引导跳转
    if (isIframeBol) {
      webDocs()
    } else {
      // 兼容创建企业的跳转
      pcOffice()
    }
  }
  const docsIpad = () => {
    if (isIframeBol) {
      toWebDocsHome(companyId, groupid, isIframeBol)
    } else if (groupid) {
      // 金山文档客户端
      window.webkit.messageHandlers.invokeKDocsApi.postMessage({
        apiName: 'toHomeByPath',
        params: {
          homeUrl: `/ent/${companyId}/${groupid}?n_redirect=0`,
          closeCurrentPage: true,
        },
      })
    } else {
      // 金山文档客户端
      window.webkit.messageHandlers.invokeKDocsApi.postMessage({
        "apiName": "toHomeByPath",
        "params": {
          "homeUrl": `/ent/${companyId}/helper?n_redirect=0`,
          "closeCurrentPage": true
        }
      })
    }
  }
  const docsAnPad = () => {
    if (isIframeBol) {
      toWebDocsHome(companyId, groupid, isIframeBol)
    } else {
      const params = JSON.stringify({homeUrl: `/ent/${companyId}/helper?n_redirect=0`,closeCurrentPage: "true"})
      // 金山文档客户端
      window.WPSDoc.invoke("yun", "toHomeByPath", params, "emptyCb")
    }
  }
  const docsPc = () => {
    if (noSwitchAccount) {
      try {
        const clientName = clientApi.getCurrentClient()
        clientApi.switchAccount({ clientName, userid, companyid: companyId })
      } catch (e) {}
    }
    // 金山文档客户端
    window.parent.postMessage(
      JSON.stringify({
        eventName: 'toTeamPage',
        companyId: companyId,
        tempId: groupid
      }),
      '*'
    )
    setTimeout(() => window.close(), 500)
  }
  const docsMac = () => {
    if (noSwitchAccount) {
      try {
        const clientName = clientApi.getCurrentClient()
        clientApi.switchAccount({ clientName, userid, companyid: companyId })
      } catch (e) {}
    }
    // 金山文档客户端
    window.parent.postMessage(
      JSON.stringify({
        eventName: 'toTeamPage',
        companyId: companyId,
        tempId: groupid
      }),
      '*'
    )
    setTimeout(() => window.close(), 500)
  }
  const pcOffice = () => {
    let version = getPcVersion()
    const isVba = isVBAWorkflow() && isWPSClient()
    toPcOfficeHome(companyId, groupid, version, url, isVba, isIframeBol)
  }
  const webDocs = () => {
    toWebDocsHome(companyId, groupid, isIframeBol, { isGuideWorkbench })
  }
  const docsMobile = () => {
    try {
      const clientName = clientApi.getCurrentClient()
      // 金山文档客户端
      clientApi.toEnterprise({
        clientName,
        type: 'team',
        companyid: companyId,
        companyname: companyName,
      })
    } catch (e) {}

  }

  const miniprogram = () => {
    wx.miniProgram.reLaunch({
      // url: `/pages/companyList/companyList?companyid=${companyId}&name=${companyName}`,
      url: `/pages/tabBars/teams/teams?companyid=${companyId}&name=${companyName}`,
    })
  }

  const qqminiprogram = () => {
    window.qq &&
      window.qq.miniProgram.reLaunch({
        // url: `/pages/companyList/companyList?companyid=${companyId}&name=${companyName}`,
        url: `/pages/tabBars/teams/teams?companyid=${companyId}&name=${companyName}`,
      })
  }

  const iosOfficeMobile = () => {
    if (!window?.wps?.switchDocumentTab) return false
    return window.wps.switchDocumentTab({
      companyId: companyId,
      companyName: companyName,
    })
  }

  const anOfficeMobile = () => {
    const fn = () => window.location.href = `wpsoffice://wps.cn/root?key_switch_tab=document&key_open_companyid=${companyId}`
    // 更新身份信息
    if (window.wps?.updateWorkspace) {
      window.wps?.updateWorkspace({
        complete: (res) => {
          fn()
        }
      })
    } else {
      fn()
    }

    // if (!window?.wps?.switchDocumentTab) return false
    // const clientInfo = window.wps.getSystemInfo()
    // let verArr = clientInfo.version.split('.')
    // const verLen = 3
    // while (verArr.length < verLen) {
    //   verArr.push(0)
    // }
    // if (+verArr.join('') >= 1205) {
    //   window.location.href = `wpsoffice://wps.cn/wps_drive?type=27&id=${companyId}&inside=true`
    //   window.wps && window.wps.closeWeb()
    // } else {
    //   window.location.href = `wpsoffice://wps.cn/root?key_switch_tab=document&key_open_companyid=${companyId}`
    // }
    return
  }

  const wechath5 = () => {
    ConditionalJumpLink.pushState('//www.kdocs.cn/m/')
  }

  const actions = new Map([
    ['default', defaultAction],
    ['false_docsWeb', webDocs],
    ['true_WPS365_PC', wps365], // WPS365
    ['false_docsIpad', docsIpad],
    ['false_docsAnPad', docsAnPad],
    ['false_docsPc', docsPc],
    ['false_docsMac', docsMac],
    ['true_pcoffice', pcOffice],
    ['true_macoffice', pcOffice],
    ['false_docsIos', docsMobile],
    ['false_docsAn', docsMobile],
    ['false_wechath5', wechath5],
    ['false_miniprogram', miniprogram],
    ['false_qqminiprogram', qqminiprogram],
    ['false_wxminiprogram', miniprogram],
    ['false_iOSoffice', iosOfficeMobile],
    ['false_anoffice', anOfficeMobile],
    ['false_iOSofficePad', iosOfficeMobile],
    ['false_anofficePad', anOfficeMobile],
  ])
  let action = actions.get(`${isWPSClient()}_${source}`) || actions.get('default')
  action && action.call(this)
}

/**
 * 判断pc端和mac端
 * @param {String} source
 */
export const isMacOrPc = source => {
  return ['WPS365_PC', 'pcoffice', 'macoffice'].includes(source)
}

export const isVBAWorkflow = () => {
  const utm_source: any = getQuery('utm_source')
  const utm_medium = getQuery('utm_medium')
  return ['WPS365_PC', 'pcoffice', 'macoffice'].includes(utm_source) && utm_medium === 'vba'
}

// 判断是否海外
// export const isAbroad  = import.meta.env.IS_ABROAD
export const isAbroad = import.meta.env.VUE_APP_IS_ABROAD


// 设置客户端版本到window
export const setAppVersionInWindow = async () => {
  try {
    let res = await getAppInfo()
    if (!res) res = {}
    window.appInfo = res
  } catch (e) {
    console.debug('error: getAppInfo')
  }
}

// 获取文件后缀名
export function getFileExtendingName (filename) {
  // 文件扩展名匹配正则
  const reg = /\.[^\.]+$/;
  const matches = reg.exec(filename);
  if (matches) {
    return matches[0];
  }
  return '';
}

// 是wps移动端，IOS、安卓、安卓pad、Ipad
export const getWpsMobileClient = () => {
  const clientFlag = clientApi.getCurrentClient()
  return [
    'isWpsIosClient',
    'isWpsAnClient',
    'isWpsIpadClient',
    'isWpsAnPadClient',
  ].includes(clientFlag)
}

// 是金山文档移动端，IOS、安卓
export const getDocsMobileClient = () => {
  const clientFlag = clientApi.getCurrentClient()
  return [
    'isDocsIosClient',
    'isDocsAnClient',
  ].includes(clientFlag)
}

// 获取设置来源，备注：目前不需要区分容器来源，故此直接固定对应的业务来源即可
export const getCurrentSource = async () => {
  if (isWPSClient()) {
    return 'createCompanyEntry'
  }

  return ''
  // const clientName = clientApi.getCurrentClient()
  //
  // // WPS小程序不支持getCurrentSource接口，直接返回空
  // if (isWPSMiniProgram()) {
  //   return ''
  // }
  //
  // try {
  //   const res = await clientApi.getCurrentSource({ clientName })
  //   return res?.source || ''
  // } catch (e) {
  //   return ''
  // }
}

/**
 * @desc 跳转到团队列表
 * @param companyId
 */
export const goEntGroupsByClient = async (companyId) => {
  const isClient = isWPSClient()
  const isIframeBol = isIframe()
  if (isClient) {
    sendCommand(
      `plugin://pageStartPage?locateCloudCompany&activate&${companyId}`
    )
  } else if (isIframeBol) {
    // 走旧逻辑
    goHomeByClient(companyId)
  } else {
    singleSign.onSkipSingleSign({ cbUrl: `${SaasAxios.getHost('KDOCS')}/entgroups` })
  }
}


/**
 * 根据文件计算SHA256
 * @param file 
 * @returns 
 */
export const calculateSHA256 = async (file: File) => {
  const buffer = await file.arrayBuffer()
  const hashBuffer = await crypto.subtle.digest("SHA-256", buffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("")
  return hashHex
}